module.exports = __webpack_public_path__ + "static/img/fmch.d6761507.jpg";